(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  /* ==========================================================
     LEADWAY FLEXIBLE MEGA MENU BLOCKS
     Moves Theme Editor blocks into the matching top-level mega menu.
     Matching is case-insensitive and ignores extra whitespace.
     ========================================================== */
  function initLeadwayMobileMenuBlocks() {
    const sourceBlocks = document.querySelectorAll(
      '.leadway-menu-blocks-source > [data-leadway-menu-block]'
    );

    if (!sourceBlocks.length) return;

    const normalize = (value) => (value || '').replace(/\s+/g, ' ').trim().toLowerCase();

    sourceBlocks.forEach((block) => {
      if (block.dataset.leadwayMobileCloned === 'true') return;

      const target = normalize(block.dataset.menuTarget);
      if (!target) return;

      let matchedItem = null;

      document.querySelectorAll('.menu-drawer__menu > li').forEach((item) => {
        if (matchedItem) return;

        const summary = item.querySelector(':scope > details > summary.menu-drawer__menu-item');
        const directLink = item.querySelector(':scope > a.menu-drawer__menu-item');
        const labelSource = summary || directLink;

        if (!labelSource) return;

        const label = normalize(labelSource.textContent);
        if (label === target) matchedItem = item;
      });

      if (!matchedItem) return;

      let wrapper = matchedItem.querySelector(':scope > .leadway-mobile-custom-content');

      if (!wrapper) {
        wrapper = document.createElement('div');
        wrapper.className = 'leadway-mobile-custom-content';
        wrapper.setAttribute('data-leadway-mobile-content', 'true');

        const details = matchedItem.querySelector(':scope > details');
        const submenu = details
          ? details.querySelector(':scope > .menu-drawer__submenu')
          : null;

        if (submenu) {
          submenu.appendChild(wrapper);
        } else {
          matchedItem.appendChild(wrapper);
        }
      }

      const clone = block.cloneNode(true);
      clone.removeAttribute('aria-hidden');
      clone.removeAttribute('data-shopify-editor-block');
      clone.dataset.leadwayMobileClone = 'true';
      clone.removeAttribute('data-leadwayMenuMoved');

      wrapper.appendChild(clone);
      block.dataset.leadwayMobileCloned = 'true';
    });
  }

  function initLeadwayMenuBlocks(root) {
    /* Build mobile copies before the original blocks are moved into
       the desktop mega-menu. */
    initLeadwayMobileMenuBlocks();

    const scope = root || document;
    const sources = scope.querySelectorAll
      ? scope.querySelectorAll('.leadway-menu-blocks-source > [data-leadway-menu-block]')
      : [];

    if (!sources.length) return;

    const normalize = (value) => (value || '').replace(/\s+/g, ' ').trim().toLowerCase();

    sources.forEach((block) => {
      if (block.dataset.leadwayMenuMoved === 'true') return;

      const target = normalize(block.dataset.menuTarget);
      if (!target) return;

      const menus = document.querySelectorAll('.header__inline-menu details.mega-menu');
      let matchedMenu = null;

      menus.forEach((menu) => {
        if (matchedMenu) return;
        const summary = menu.querySelector(':scope > summary');
        if (!summary) return;
        const labelElement = summary.querySelector('span');
        const label = normalize(labelElement ? labelElement.textContent : summary.textContent);
        if (label === target) matchedMenu = menu;
      });

      if (!matchedMenu) return;

      const content = matchedMenu.querySelector(':scope > .mega-menu__content');
      if (!content) return;

      const position = block.dataset.menuPosition || 'after';
      const wrapperClass = `leadway-menu-custom-content--${position}`;
      let wrapper = content.querySelector(`:scope > .leadway-menu-custom-content.${wrapperClass}`);

      if (!wrapper) {
        wrapper = document.createElement('div');
        wrapper.className = `leadway-menu-custom-content ${wrapperClass}`;

        if (position === 'before') {
          content.insertBefore(wrapper, content.firstElementChild);
        } else {
          content.appendChild(wrapper);
        }
      }

      wrapper.appendChild(block);
      block.dataset.leadwayMenuMoved = 'true';
      block.removeAttribute('aria-hidden');
    });

    document.querySelectorAll('.header__inline-menu details.mega-menu').forEach((menu) => {
      menu.querySelectorAll(':scope > .mega-menu__content > .leadway-menu-custom-content').forEach((wrapper) => {
        if (!wrapper.children.length) wrapper.remove();
      });

      const nativeList = menu.querySelector(':scope > .mega-menu__content > .mega-menu__list');
      const hasNativeItems = !!(nativeList && nativeList.querySelector(':scope > li'));
      const hasCustomContent = !!menu.querySelector(':scope > .mega-menu__content > .leadway-menu-custom-content > *');

      if (hasCustomContent && !hasNativeItems) {
        menu.classList.add('leadway-mega-menu--custom-only');
      } else {
        menu.classList.remove('leadway-mega-menu--custom-only');
      }
    });
  }

  /* Keep desktop mega-menu panels tightly sized to their actual content.
     Dawn's native mega-menu CSS can apply a larger minimum height, so we
     explicitly reset it whenever a menu opens or its content changes. */
  function fitLeadwayMegaMenus() {
    if (!window.matchMedia('(min-width: 990px)').matches) return;

    const viewportWidth = window.innerWidth;
    const sideMargin = Number('{{ section.settings.mega_menu_side_margin }}') || 48;
    const configuredMax = Number('{{ section.settings.mega_menu_max_width }}') || 1400;
    const availableWidth = Math.max(320, viewportWidth - (sideMargin * 2));
    const header = document.querySelector('.header');
    const headerRect = header ? header.getBoundingClientRect() : null;
    const top = headerRect
      ? Math.round(headerRect.bottom + (Number('{{ section.settings.mega_menu_top_offset }}') || 0))
      : Math.round(100 + (Number('{{ section.settings.mega_menu_top_offset }}') || 0));

    document.documentElement.style.setProperty('--leadway-mega-menu-top', `${top}px`);

    document.querySelectorAll('.header__inline-menu details.mega-menu').forEach((menu) => {
      const content = menu.querySelector(':scope > .mega-menu__content');
      if (!content) return;

      const nativeList = menu.querySelector(':scope > .mega-menu__content > .mega-menu__list');
      const customWrapper = menu.querySelector(':scope > .mega-menu__content > .leadway-menu-custom-content');
      const topLevelItems = nativeList
        ? Array.from(nativeList.querySelectorAll(':scope > li'))
        : [];
      const hasNativeItems = topLevelItems.length > 0;
      const customBlocks = customWrapper ? Array.from(customWrapper.children) : [];

      const nestedColumns = topLevelItems.filter((item) => {
        const nested = item.querySelector(':scope > ul, :scope > .mega-menu__link + ul');
        return nested && nested.querySelector(':scope > li');
      }).length;

      let columns = 1;
      let menuType = 'simple';

      if (nestedColumns > 0) {
        menuType = 'mega';
        columns = Math.min(
          nestedColumns,
          Number('{{ section.settings.mega_menu_columns }}') || nestedColumns
        );
        if (viewportWidth < 1200) columns = Math.min(columns, 3);
      } else if (customBlocks.length) {
        menuType = 'custom';
        customBlocks.forEach((block) => {
          if (block.classList.contains('leadway-menu-block--half')) columns = Math.max(columns, 2);
          if (block.classList.contains('leadway-menu-block--third')) columns = Math.max(columns, 3);
          if (block.classList.contains('leadway-menu-block--quarter')) columns = Math.max(columns, 4);
        });
      }

      menu.classList.toggle('leadway-simple-menu', menuType === 'simple' && !customBlocks.length);

      let finalWidth;
      if (menuType === 'simple') {
        /* Do not measure hidden DETAILS content. A measurement on click causes
           the panel to repaint at one width and then jump to another. */
        finalWidth = hasNativeItems ? 620 : 520;
      } else if (menuType === 'custom') {
        finalWidth = Math.min(
          configuredMax,
          Math.max(520, Math.min(900, 520 + (columns - 1) * 170))
        );
      } else {
        const widthPerColumn = 285;
        const baseWidth = 430;
        finalWidth = baseWidth + Math.max(0, columns - 1) * widthPerColumn;
      }

      finalWidth = Math.min(availableWidth, configuredMax, Math.max(520, finalWidth));
      content.style.setProperty('--leadway-mega-menu-width', `${Math.round(finalWidth)}px`, 'important');
      content.style.setProperty('--leadway-mega-columns', String(Math.max(1, columns)), 'important');
      content.style.setProperty('height', 'fit-content', 'important');
      content.style.setProperty('min-height', '0px', 'important');
      content.style.setProperty('max-height', 'none', 'important');
      content.style.setProperty('bottom', 'auto', 'important');
      content.style.setProperty('inset-block-end', 'auto', 'important');
      content.style.setProperty('align-self', 'flex-start', 'important');
    });
  }

  /* ==========================================================
     MOBILE DRAWER TOGGLE CONTROL
     Dawn's header-drawer script also listens to mobile SUMMARY clicks.
     Because the mobile submenus are intentionally inline, letting both
     handlers react to the same click can open the submenu and then close
     or reposition it again. Handle the drawer disclosure ourselves on
     mobile so each tap has exactly one state change.
     ========================================================== */
  document.addEventListener('click', (event) => {
    if (window.innerWidth >= 990) return;

    const summary = event.target.closest(
      '.menu-drawer summary.menu-drawer__menu-item'
    );
    if (!summary) return;

    const details = summary.parentElement;
    if (!(details instanceof HTMLDetailsElement)) return;

    /* Only take over actual submenu disclosures. */
    const submenu = details.querySelector(':scope > .menu-drawer__submenu');
    if (!submenu) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    const willOpen = !details.open;

    /* Keep only one disclosure open at the same menu level. */
    if (willOpen) {
      const parentList = details.parentElement;
      if (parentList) {
        parentList.querySelectorAll(':scope > li > details[open]').forEach((other) => {
          if (other !== details) {
            other.removeAttribute('open');
            const otherSummary = other.querySelector(':scope > summary.menu-drawer__menu-item');
            if (otherSummary) otherSummary.setAttribute('aria-expanded', 'false');
          }
        });
      }
      details.setAttribute('open', '');
      summary.setAttribute('aria-expanded', 'true');
    } else {
      details.removeAttribute('open');
      summary.setAttribute('aria-expanded', 'false');

      /* Closing a parent also closes any nested disclosures inside it. */
      details.querySelectorAll('details[open]').forEach((nested) => {
        nested.removeAttribute('open');
        const nestedSummary = nested.querySelector(':scope > summary.menu-drawer__menu-item');
        if (nestedSummary) nestedSummary.setAttribute('aria-expanded', 'false');
      });
    }

    /* Let layout settle without invoking Dawn's drawer animation logic. */
    requestAnimationFrame(() => {
      initLeadwayMobileMenuBlocks();
    });
  }, true);

  document.addEventListener('DOMContentLoaded', () => {
    initLeadwayMobileMenuBlocks();
    initLeadwayMenuBlocks(document);
    fitLeadwayMegaMenus();
  });
  document.addEventListener('shopify:section:load', (event) => {
    initLeadwayMobileMenuBlocks();
    initLeadwayMenuBlocks(event.target);
    fitLeadwayMegaMenus();
  });

  document.addEventListener('toggle', (event) => {
    if (event.target instanceof HTMLDetailsElement && event.target.matches('.header__inline-menu details.mega-menu')) {
      /* Opening/closing must not trigger a width or position recalculation.
         The panel is pre-sized during initialization/resizing, so the click
         only changes DETAILS[open] and never causes a second paint/jump. */
      initLeadwayMobileMenuBlocks();
      initLeadwayMenuBlocks(document);
    }
  }, true);

  window.addEventListener('resize', fitLeadwayMegaMenus);
  initLeadwayMobileMenuBlocks();
  initLeadwayMenuBlocks(document);
  fitLeadwayMegaMenus();

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
